/*
 * Màn chờ: tắt khi ảnh LCP (img[data-lcp]) đã giải mã xong, chậm nhất MAX_WAIT để không giam người dùng.
 * decode() tránh khoảnh khắc ảnh hiện từng mảng ngay sau khi loader tắt.
 */
const MAX_WAIT = 2500;

export function initLoader() {
  const html = document.documentElement;
  let done = false;
  const finish = () => {
    if (done) return;
    done = true;
    html.classList.add('is-loaded');
  };
  setTimeout(finish, MAX_WAIT);

  const lcp = Array.from(document.querySelectorAll('img[data-lcp]')).find((img) => img.offsetParent !== null);
  if (!lcp) {
    requestAnimationFrame(finish);
    return;
  }
  const ready = lcp.complete ? Promise.resolve() : new Promise((res) => {
    lcp.addEventListener('load', res, { once: true });
    lcp.addEventListener('error', res, { once: true });
  });
  ready.then(() => (lcp.decode ? lcp.decode().catch(() => {}) : null)).then(finish);
}
